import { c as _c } from "react/compiler-runtime";
import type { ChainId } from '@morpho-org/blue-sdk';
import type { SortingState } from '@tanstack/react-table';
import { useCursorPagination } from '@/hooks/useCursorPagination';
import { COLUMN_TO_SORT_BY } from '../config';
import { fetchMarketBorrowersPage, marketBorrowersTableQueryKey } from '../config/queryKey';
interface UseMarketBorrowersDataParams {
  chainId: ChainId;
  marketId: string;
  first: number;
  sorting: SortingState;
}

/**
 * Cursor-paginated data hook for the market borrowers table, over `market.borrowers`. Without a
 * sorted column the procedure sorts by borrow shares, largest first, the key the server hydrates.
 */
const useMarketBorrowersData = t0 => {
  const $ = _c(12);
  const {
    chainId,
    marketId,
    first,
    sorting
  } = t0;
  const firstSort = sorting[0];
  const sortBy = firstSort ? COLUMN_TO_SORT_BY[firstSort.id] : undefined;
  const sortDirection = sortBy && firstSort ? firstSort.desc ? "desc" : "asc" : undefined;
  let t1;
  let t2;
  let t3;
  if ($[0] !== chainId || $[1] !== first || $[2] !== marketId || $[3] !== sortBy || $[4] !== sortDirection) {
    const filters = {
      chainId,
      marketId,
      sortBy,
      sortDirection,
      limit: first
    } as const;
    t2 = useCursorPagination;
    t1 = marketBorrowersTableQueryKey(filters);
    t3 = cursor => fetchMarketBorrowersPage(filters, cursor);
    $[0] = chainId;
    $[1] = first;
    $[2] = marketId;
    $[3] = sortBy;
    $[4] = sortDirection;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
  }
  const t4 = `${chainId}:${marketId}:${sortBy ?? "-"}:${sortDirection ?? "-"}:${first}`;
  let t5;
  if ($[8] !== t1 || $[9] !== t3 || $[10] !== t4) {
    t5 = {
      queryKey: t1,
      queryFn: t3,
      resetKey: t4,
      trustCursorOnEmptyPage: true
    };
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t2(t5);
};
export default useMarketBorrowersData;